var ctrl = function($scope, $rootScope, $state) {
  $scope.disabled = false;
  $scope.markets = angular.copy($rootScope.adminMarkets);
  if ($scope.allowAll) {
    $scope.markets.unshift({code: '', name: 'All Markets'});
  }
  _.each($scope.markets, function(market) {
    if (market.state) {
      market.displayName = market.name + ", " + market.state;
    } else {
      market.displayName = market.name;
    }
  });

  if ($scope.bindModel) {
    $scope.bindModel = $scope.bindModel.toString();
  }
  var disableMarketSelectStates = [
    'layout.sculpture_matcher.index',
    'layout.sculpture_retailers.index',
    'layout.brand_families',
    'layout.categories.index',
    'layout.changelogs.index',
    'layout.custom_urls.index',
    'layout.distributor_accounts.index',
    'layout.integrations.index',
    'layout.inventory_queue.index',
    'layout.lists.index',
    'layout.manufacturers.index',
    'layout.product_lines.index',
    'layout.product_review_queue.index',
    'layout.product_sizes.index',
    'layout.quick_order_wizard.index',
    'layout.sales_reps.index',
    'layout.sales_reps.vacations.index',
    'layout.tags.index',
    'layout.unseen_messages.index',
    'layout.uploads.index',
    'layout.market',
    'layout.market.signup',
    'layout.market.settings',
    'layout.market.launcher',
    'layout.distribution_areas.index',
    'layout.distribution_areas.overlaps',
    'layout.discounts.index'
  ];
  var setDisabled = function() {
    $scope.disabled = _.includes(disableMarketSelectStates, $state.current.name);
  }
  $scope.$on('$stateChangeSuccess', function() {
    setDisabled();
  });
  setDisabled();
};

ctrl.$inject = ["$scope", '$rootScope', '$state'];

tiz.controller("marketSelectCtrl", ctrl);
tiz.directive("marketSelect", function() {
  return {
    scope: {
      only: "=only",
      bindModel: "=ngModel",
      allowAll: '='
    },
    templateUrl: require('../templates/market_select.html'),
    controller: "marketSelectCtrl"
  };
});
